import React from 'react'

const MessageSubHeading = ({ text, className, noMargin, loadingHide, custom }) => {
    return (
        <p className={`${className} ${(!text?.length && !loadingHide) ? "subHeadingLoader square" : ""}  ${!noMargin && 'mb-3'} ${!custom && "mt-0 theme-text-color opacity-75 admin-input-description"}`}>{text}</p>
    )
}
export default MessageSubHeading